export default __webpack_public_path__ + "static/media/iconXLS.cac78a8e.svg";